import { ChangeLog, Response, apiAbortController } from '@ui/src';
import api from '../../../../api/api';
import {
  CreateRoleRequest,
  EditRoleRequest,
  RoleDetails,
  RoleValidator,
} from '../../types';

export const userRolesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRoles: build.query<Response<RoleDetails>, string>({
      query: (query) => ({
        url: `/v1/employees-roles-templates?take=9999&${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRole: build.query<{ data: RoleDetails }, string>({
      query: (id) => ({
        url: `/v1/employees-roles-templates/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createRole: build.mutation<{ data: RoleDetails }, CreateRoleRequest>({
      query: (body) => ({
        url: '/v1/employees-roles-templates',
        method: 'POST',
        body: {
          name: body.name,
          usersIds: body.userIds || [],
          permissions: [],
          notificationTypeTemplateId:
            body.notificationTypeTemplateId || undefined,
          active: true,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    editRole: build.mutation<
      { data: RoleDetails },
      { body: EditRoleRequest; id: string }
    >({
      query: (data) => ({
        url: `/v1/employees-roles-templates/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRoleValidators: build.query<{ data: RoleValidator }, void>({
      query: () => ({
        url: '/v1/employees-roles-templates/validators',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRoleChangeLogs: build.query<Response<ChangeLog>, string>({
      query: (query) => ({
        url: `/v1/audit-log${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetRolesQuery,
  useLazyGetRoleQuery,
  useGetRoleValidatorsQuery,
  useLazyGetRoleValidatorsQuery,
  useCreateRoleMutation,
  useEditRoleMutation,
  useLazyGetRoleChangeLogsQuery,
} = userRolesApi;

export const {
  endpoints: { getRoles, getRole, createRole, editRole, getRoleValidators },
} = userRolesApi;
